import { observeElement, getWidget } from '@uvocore-front/utils';

/* eslint-disable no-undef */
const isPageConfig = window.pageConfig
  && Object.keys(window.pageConfig).length > 0
  && window.pageConfig.constructor === Object;

// Calculator Observer
if (document.querySelector('[data-calculator-default]')) {
  observeElement({
    element: '[data-calculator-default]',
    marginValue: 200,
    callback: () => {
      getWidget({
        widgetLink: '/assets/js/calc.js',
        loader: false,
        fn: () => {
          const pagePaperType = isPageConfig && (window.pageConfig.calculator !== undefined && window.pageConfig.calculator.hasOwnProperty('pagePaperType')) /* eslint-disable-line */
            ? window.pageConfig.calculator.pagePaperType
            : undefined;

          const deadlineDefault = isPageConfig && (window.pageConfig.calculator !== undefined && window.pageConfig.calculator.hasOwnProperty('deadlineDefault')) /* eslint-disable-line */
            ? window.pageConfig.calculator.deadlineDefault
            : undefined;

          const calcOptions = {
            ID: '15',
            calculatorType: 'DefaultCalculator',
            format: 'html',
            options: {
              deafault: {
                deadlinesDefault: [105301, 105349, 105399, 105439, 105487],
              },
            },
          };

          if (pagePaperType !== undefined) {
            calcOptions.options.deafault.paperTypesDefault = pagePaperType;
          }

          if (deadlineDefault !== undefined) {
            calcOptions.options.deafault.deadlinesDefault = [deadlineDefault];
          }

          const calc = new Calc(calcOptions); /* eslint-disable-line */
        },
      });
    },
  });
}

if (document.querySelector('[data-calculator-short]')) {
  observeElement({
    element: '[data-calculator-short]',
    marginValue: 200,
    callback: () => {
      getWidget({
        widgetLink: '/assets/js/calc.js',
        loader: false,
        fn: () => {
          const pagePaperType = isPageConfig && (window.pageConfig.calculator !== undefined && window.pageConfig.calculator.hasOwnProperty('pagePaperType')) /* eslint-disable-line */
            ? window.pageConfig.calculator.pagePaperType
            : undefined;

          const calcOptions = {
            ID: '15',
            calculatorType: 'DefaultCalculator',
            format: 'json',
            parent: '[data-calculator-short]',
            options: {
              deafault: {
                academicLevelDefault: 2,
              },
            },
          };

          if (pagePaperType !== undefined) {
            calcOptions.options.deafault.paperTypesDefault = pagePaperType;
          }

          const calc = new Calc(calcOptions); /* eslint-disable-line */
        },
      });
    },
  });
}
